/**
 * usePageTracking — hook لتتبع مشاهدات الصفحات تلقائياً
 * يُستدعى في كل صفحة عامة لتسجيل الزيارة
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * يتتبع مشاهدة الصفحة الحالية تلقائياً عند التنقل
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // تأخير بسيط لضمان تحميل الصفحة
    const timer = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 500);
    return () => clearTimeout(timer);
  }, [location.pathname, location.search]);
}

/**
 * يتتبع مشاهدة مقال محدد
 */
export function useArticleTracking(articleSlug: string, articleId?: number) {
  useEffect(() => {
    if (!articleSlug) return;
    const timer = setTimeout(() => {
      // تسجيل مشاهدة الصفحة
      trackPageView(`/article/${articleSlug}`, articleSlug);
    }, 1000); // ثانية كاملة للتأكد أن الزائر قرأ المقال
    return () => clearTimeout(timer);
  }, [articleSlug, articleId]);
}
